import { atom } from 'recoil';

/**
 * 運営問い合わせのモバイルにいるかどうかのstate
 * avatarのサイズが小さくなる
 */
export const isInMobileContactRoomFlag = atom({
  key: 'isInMobileContactRoomFlag',
  default: false,
});
